<script setup lang="ts">
import Leagues from "./SwipeBetLeagues.vue";
import { IRegion } from "~/types/sports/region";
import t from "~/utils/translate";
import { IfilterData, ISelection } from "~/types/swipe-bet/filter";
import Dropdown from "~/components/ui/Form/Dropdown.vue";
import isEqual from "lodash/isEqual";
import Modal from "~/components/ui/Modal.vue";

interface Props {
	data: IfilterData[];
	preSelections: ISelection[];
	active: "type-sort" | "leagues" | "date" | "odds" | boolean;
}

const props = defineProps<Props>();
const emits = defineEmits(["handle-submit", "setActive"]);

const selectedFilter = ref("");
const filteredData = ref<IRegion[]>([]);
const selected = ref<ISelection[]>([]);

onMounted(() => {
	filteredData.value = props?.data?.find((item) => item.name === "soccer")?.regions ?? [];
	selectedFilter.value = "soccer";

	selected.value = props.preSelections;
});

const selectFilter = () => {
	filteredData.value = (props?.data || []).find((item) => item.name === selectedFilter.value)?.regions || [];
};

const handleReset = () => {
	selected.value = [];
};

const handleSubmit = () => {
	emits("handle-submit", selected.value);
};

const handleAddRegion = (val: { leagueId: string; regionId: string }) => {
	selected.value = [...(selected.value || []), { sport: selectedFilter.value, leagueId: val.leagueId, regionId: val.regionId }];
};

const handleRemoveRegion = (val: { leagueId: string; regionId: string }) => {
	if (selected.value) selected.value = [...selected.value.filter((x) => x.leagueId !== val.leagueId)];
};

const altered = computed(() => {
	props.preSelections.sort();
	selected.value.sort();

	return !isEqual(props.preSelections, selected.value);
});
</script>

<template>
	<Modal :content-padding="false" size="small" :title="t('filters')" :active="!!active" @set-active="(value) => emits('setActive', value)">
		<Dropdown
			v-model="selectedFilter"
			@change="selectFilter()"
			:label="t('filters')"
			class="px-2 mt-4 rounded-xl"
			:options="
				data.map((x) => {
					return {
						name: t('sports.' + x.name),
						value: x.name,
					};
				})
			"
		/>
		<div class="overflow-x-hidden overflow-y-scroll h-80 scrollbar-hidden">
			<Leagues
				:filter="filteredData"
				:selected="selected"
				@update-regions="(val) => handleAddRegion(val)"
				@remove-region="(val) => handleRemoveRegion(val)"
			/>
		</div>
		<template #footer>
			<div class="flex justify-between w-full">
				<UiButton @click="() => handleReset()" :disabled="selected.length === 0" class="w-[48%]" variant="secondary" :label="t('reset')" />
				<UiButton @click="() => handleSubmit()" :disabled="!altered" class="w-[48%]" variant="identity" :label="t('apply')" />
			</div>
		</template>
	</Modal>
</template>
